/**
 * 试卷
 */

export const ExamList = [{
    prop: "id",
    label: "id",
    width: "150",
    format: "",
    order: false,
    isShow: false,
  },
  {
    prop: "name",
    label: "试卷名称",
    width: "150",
    format: "",
    order: false,
    isShow: true,
  },
  {
    prop: "cate",
    label: "试卷分类",
    width: "150",
    format: "",
    order: false,
    isShow: true,
  },
  {
    prop: "examPeople",
    label: "参与次数",
    width: "150",
    format: "",
    order: false,
    isShow: true,
  },
  {
    prop: "totalCount",
    label: "参考人数",
    width: "150",
    format: "",
    order: false,
    isShow: true,
  },
  {
    prop: "status",
    label: "状态",
    width: "150",
    format: "status",
    order: false,
    isShow: true,
  },
  {
    prop: "creatorName",
    label: "创建人",
    width: "150",
    isShow: true
  },
  {
    prop: "creationTime",
    label: "创建时间",
    format: "datetime",
    width: "150",
    isShow: true
  }
];